import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction, IPayload } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';
import * as qs from 'qs';

import { IAdvertising, defaultValue, ISearchForm } from 'app/shared/model/advertising.model';
import { flattenKey } from 'app/shared/util/object-utils';
// 请求
export const ACTION_TYPES = {
  FETCH_ADVERTISING_LIST: 'advertising/FETCH_ADVERTISING_LIST', // 请求列表
  FETCH_ADVERTISING: 'advertising/FETCH_ADVERTISING',
  CREATE_ADVERTISING: 'advertising/CREATE_ADVERTISING', // 新建
  UPDATE_ADVERTISING: 'advertising/UPDATE_ADVERTISING', // 更新
  DELETE_ADVERTISING: 'advertising/DELETE_ADVERTISING', // 删除
  RESET: 'advertising/RESET'
};
// 定义state类型
const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IAdvertising>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
  totalItems: 0
};

export type AdvertisingState = Readonly<typeof initialState>;

// Reducer

export default (state: AdvertisingState = initialState, action): AdvertisingState => {
  // 更具type请求
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_ADVERTISING_LIST):
    case REQUEST(ACTION_TYPES.FETCH_ADVERTISING):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_ADVERTISING):
    case REQUEST(ACTION_TYPES.UPDATE_ADVERTISING):
    case REQUEST(ACTION_TYPES.DELETE_ADVERTISING):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_ADVERTISING_LIST):
    case FAILURE(ACTION_TYPES.FETCH_ADVERTISING):
    case FAILURE(ACTION_TYPES.CREATE_ADVERTISING):
    case FAILURE(ACTION_TYPES.UPDATE_ADVERTISING):
    case FAILURE(ACTION_TYPES.DELETE_ADVERTISING):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_ADVERTISING_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_ADVERTISING):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_ADVERTISING):
    case SUCCESS(ACTION_TYPES.UPDATE_ADVERTISING):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_ADVERTISING):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/advertisings';

// Actions
export declare type ICrudGetListAction<T> = (
  page?: number,
  size?: number,
  sort?: string,
  searchForm?: ISearchForm
) => IPayload<T> | ((dispatch: any) => IPayload<T>);
export const getEntities: ICrudGetListAction<IAdvertising> = (page, size, sort, searchForm) => ({
  type: ACTION_TYPES.FETCH_ADVERTISING_LIST,
  payload: axios.get<IAdvertising>(`${apiUrl}?cacheBuster=${new Date().getTime()}`, {
    params: flattenKey(searchForm),
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'indices' })
  })
});

export const getEntity: ICrudGetAction<IAdvertising> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_ADVERTISING,
    payload: axios.get<IAdvertising>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IAdvertising> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_ADVERTISING,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IAdvertising> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_ADVERTISING,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<IAdvertising> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_ADVERTISING,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
